// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.review-portal-wrapper {
  width: 100%;
}

.progress-bar-container {
  width: 100%;
}

.content {
  display: flex;
  width: 100%;
  margin-top: 1%;
}

.filters-column {
  width: 20%;
  min-width: 160px;
  margin-right: 2%;
}

.filter-header {
  display: flex;
  align-items: center;
  margin-bottom: 5%;
}
.filter-header h6 {
  font-family: "GothamBold", Arial, sans-serif;
  margin: 0;
  flex: 1;
}
.filter-header .clear-all-btn {
  color: #0066b2;
  background-color: white;
  border: none;
  white-space: nowrap;
  cursor: pointer;
  padding: 0;
  font-size: 0.85em;
}

.table-column {
  flex: 1;
  min-width: 0;
}

.portal-hint {
  color: #0b2d71;
  margin-bottom: 1%;
  font-size: 0.9em;
}

.revisions-table {
  display: flex;
  margin-top: 1%;
  overflow-x: auto;
}

.mat-table {
  min-width: 100%;
  border: 1px solid #e3e3e3;
  border-radius: 3px;
}
.mat-table a.revision-link {
  color: #0066b2;
  cursor: pointer;
  text-decoration: none;
}
.mat-table a.revision-link:hover {
  text-decoration: underline;
}

.faSort {
  margin-left: 4px;
  font-size: 0.75em;
  opacity: 0.6;
}

.no-data-cell {
  padding: 16px;
  text-align: center;
  color: #e3e3e3;
  font-style: italic;
}

.load-error-message {
  padding: 16px;
  color: #97002e;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
